import styled from 'styled-components'

import Breadcrumb from '../../components/Breadcrumb'
import { mobileBreadcrumbStyles } from '../../components/Breadcrumb/styled'

export const TemplateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const Main = styled.article`
  background: ${({ theme }) => theme.colors.greyf5};
`

export const MobileBreadcrumb = styled(Breadcrumb)`
  ${mobileBreadcrumbStyles}
`
